<template>
  <div class="TSN">
    <!-- ① Full-bleed hero with overlay title/body/body1 (desktop: left-aligned, black title, body on gradient) -->
    <section class="bleed-row first-row">
      <picture>
        <source media="(max-width: 899px)" :srcset="phoneSrc" />
        <img
          :src="webSrc"
          :alt="t('TskSelectNeedle.AppShell.s1.title')"
          class="row-img"
          loading="lazy"
        />
      </picture>

      <div class="overlay overlay-left mpos-top">
        <h3 class="ov-title" v-html="t('TskSelectNeedle.AppShell.s1.title')"></h3>
        <!-- Desktop: True 34G (gradient box) -->
        <p class="ov-body gradient-box bodyp desktop-only" v-html="t('TskSelectNeedle.AppShell.s1.body')"></p>
        <!-- Mobile: 舒萊特 尖針 (plain text) -->
        <p class="ov-body mobile-subtitle mobile-only" v-html="t('TskSelectNeedle.AppShell.s1.bodyp')"></p>
        <p class="ov-body-small" v-html="t('TskSelectNeedle.AppShell.s1.body1')"></p>
      </div>
    </section>

    <!-- ② interstitial-bleed (TSN s2) -->
    <section class="interstitial-bleed tsn-s2">
      <div class="interstitial-inner">
        <h3 class="inter-title" v-html="t('TskSelectNeedle.AppShell.s2.title')"></h3>
        <p class="inter-body body1" v-html="t('TskSelectNeedle.AppShell.s2.body1')"></p>
        <p class="inter-body body2" v-html="t('TskSelectNeedle.AppShell.s2.body2')"></p>
      </div>
    </section>

    <!-- ③ s3: one section; center image + overlay title; left/right texts pinned at 30%/70% -->
    <section class="tsn-s3">
      <div class="s3-center">
        <img
          :src="require('@/assets/images/AppShell/products/TSN/web/TSN_02.png')"
          alt="s3"
          class="s3-img"
          loading="lazy"
        />
        <div class="s3-overlay-title">
          <h3 class="s3-title" v-html="t('TskSelectNeedle.AppShell.s3.title')"></h3>
        </div>

        <!-- 左側 1~4：桌機定位在 30% ；手機落到圖下方 -->
        <aside class="s3-aside s3-aside-left">
          <div v-for="i in 4" :key="'s3L-'+i" class="s3-item">
            <h4 class="s3-item-title" v-html="t(`TskSelectNeedle.AppShell.s3.title${i}`)"></h4>
            <p class="s3-item-body"  v-html="t(`TskSelectNeedle.AppShell.s3.body${i}`)"></p>
          </div>
        </aside>

        <!-- 右側 5~8：桌機定位在 70% ；手機落到圖下方 -->
        <aside class="s3-aside s3-aside-right">
          <div v-for="i in [5,6,7,8]" :key="'s3R-'+i" class="s3-item">
            <h4 class="s3-item-title" v-html="t(`TskSelectNeedle.AppShell.s3.title${i}`)"></h4>
            <p class="s3-item-body"  v-html="t(`TskSelectNeedle.AppShell.s3.body${i}`)"></p>
          </div>
        </aside>
      </div>

      <!-- 手機版（<900px）專用：落到圖片下方，兩欄 × 四列 -->
      <div class="s3-mobile-grid">
        <div class="s3-mcol">
          <div v-for="i in 4" :key="'mL-'+i" class="s3-item">
            <h4 class="s3-item-title" v-html="t(`TskSelectNeedle.AppShell.s3.title${i}`)"></h4>
            <p class="s3-item-body"  v-html="t(`TskSelectNeedle.AppShell.s3.body${i}`)"></p>
          </div>
        </div>
        <div class="s3-mcol">
          <div v-for="i in [5,6,7,8]" :key="'mR-'+i" class="s3-item">
            <h4 class="s3-item-title" v-html="t(`TskSelectNeedle.AppShell.s3.title${i}`)"></h4>
            <p class="s3-item-body"  v-html="t(`TskSelectNeedle.AppShell.s3.body${i}`)"></p>
          </div>
        </div>
      </div>
    </section>
    <!-- ④ s4: web 左側 30% 疊字；手機落到圖下方 -->
    <section class="tsn-s4">
      <div class="s4-wrap">
        <picture>
          <source media="(max-width: 899px)" :srcset="require('@/assets/images/AppShell/products/TSN/phone/TSN_phone_02.png')" />
          <img
            :src="require('@/assets/images/AppShell/products/TSN/web/TSN_03.png')"
            alt="s4"
            class="s4-img"
            loading="lazy"
          />
        </picture>

        <!-- 桌機版：左 30% 疊字 -->
        <div class="s4-overlay">
          <h3 class="s4-title" v-html="t('TskSelectNeedle.AppShell.s4.title')"></h3>
          <p class="s4-body1" v-html="t('TskSelectNeedle.AppShell.s4.body1')"></p>
          <p class="s4-body2" v-html="t('TskSelectNeedle.AppShell.s4.body2')"></p>
        </div>
      </div>

      <!-- 手機版：圖片下方顯示 -->
      <div class="s4-mobile">
        <h3 class="s4-title" v-html="t('TskSelectNeedle.AppShell.s4.title')"></h3>
        <p class="s4-body1" v-html="t('TskSelectNeedle.AppShell.s4.body1')"></p>
        <p class="s4-body2" v-html="t('TskSelectNeedle.AppShell.s4.body2')"></p>
      </div>
    </section>

    <!-- ⑤ s5: web 右側 50% 疊字；手機落到圖下方 -->
    <section class="tsn-s5">
      <div class="s5-wrap">
        <picture>
          <source media="(max-width: 899px)" :srcset="require('@/assets/images/AppShell/products/TSN/phone/TSN_phone_03.png')" />
          <img
            :src="require('@/assets/images/AppShell/products/TSN/web/TSN_04.png')"
            alt="s5"
            class="s5-img"
            loading="lazy"
          />
        </picture>

        <!-- 桌機版：右 50% 疊字 -->
        <div class="s5-overlay">
          <h3 class="s5-title" v-html="t('TskSelectNeedle.AppShell.s5.title')"></h3>
          <p class="s5-body1" v-html="t('TskSelectNeedle.AppShell.s5.body1')"></p>
          <p class="s5-body2" v-html="t('TskSelectNeedle.AppShell.s5.body2')"></p>
          <p class="s5-body3" v-html="linkifiedText"></p>

          <!-- 表格 -->
          <table class="s5-table">
            <thead>
              <tr>
                <th v-html="t('TskSelectNeedle.AppShell.s5.type')"></th>
                <th v-html="t('TskSelectNeedle.AppShell.s5.cost')"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="i in 4" :key="'s5-row-'+i">
                <td v-html="t(`TskSelectNeedle.AppShell.s5.type${i}`)"></td>
                <td v-html="t(`TskSelectNeedle.AppShell.s5.cost${i}`)"></td>
              </tr>
            </tbody>
          </table>
           <p class="s5-tip" v-html="t('TskSelectNeedle.AppShell.s5.tip')"></p>
        </div>
      </div>

      <!-- 手機版：圖片下方顯示 -->
      <div class="s5-mobile">
        <h3 class="s5-title" v-html="t('TskSelectNeedle.AppShell.s5.title')"></h3>
        <p class="s5-body1" v-html="t('TskSelectNeedle.AppShell.s5.body1')"></p>
        <p class="s5-body2" v-html="t('TskSelectNeedle.AppShell.s5.body2')"></p>
        <p class="s5-body3" v-html="linkifiedText"></p>

        <!-- 表格 -->
        <table class="s5-table">
          <thead>
            <tr>
              <th v-html="t('TskSelectNeedle.AppShell.s5.type')"></th>
              <th v-html="t('TskSelectNeedle.AppShell.s5.cost')"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="i in 4" :key="'s5-row-'+i">
              <td v-html="t(`TskSelectNeedle.AppShell.s5.type${i}`)"></td>
              <td v-html="t(`TskSelectNeedle.AppShell.s5.cost${i}`)"></td>
            </tr>
          </tbody>
        </table>
        <p class="s5-tip" v-html="t('TskSelectNeedle.AppShell.s5.tip')"></p>
      </div>
    </section>

    <!-- ⑥ s6: 日本精工 -->
    <section class="tsn-s6">
      <div class="s6-content">
        <h3 class="s6-title" v-html="t('TskSelectNeedle.AppShell.s6.title')"></h3>
        <p class="s6-body" v-html="t('TskSelectNeedle.AppShell.s6.body')"></p>

        <div class="s6-images">
          <!-- Image A -->
          <div class="s6-img-group">
            <div class="img-wrapper">
              <img
                :src="require('@/assets/images/AppShell/products/TSN/web/TSN_05_01.png')"
                alt="Needle A"
                loading="lazy"
              />
            </div>
          </div>

          <!-- Image B -->
          <div class="s6-img-group">
            <div class="img-wrapper">
              <img
                :src="require('@/assets/images/AppShell/products/TSN/web/TSN_05_02.png')"
                alt="TSK SELECT NEEDLE"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ⑦ s7: 薄壁設計 -->
    <section class="tsn-s7">
      <div class="s7-content">
        <h3 class="s7-title" v-html="t('TskSelectNeedle.AppShell.s7.title')"></h3>
        <p class="s7-body" v-html="t('TskSelectNeedle.AppShell.s7.body')"></p>

        <div class="s7-diagram">
          <img
            :src="require('@/assets/images/AppShell/products/TSN/web/TSN_06.png')"
            alt="Thin Wall Design"
            class="s7-img"
            loading="lazy"
          />
        </div>
      </div>
    </section>

    <!-- ⑧ s8: Features List -->
    <section class="tsn-s8">
      <div class="s8-header">
        <h3 class="s8-title" v-html="t('TskSelectNeedle.AppShell.s8.title')"></h3>
      </div>
      <div class="s8-content">
        <div class="s8-col">
          <p v-for="i in 4" :key="'s8-l-'+i" class="s8-item" v-html="t(`TskSelectNeedle.AppShell.s8.body${i}`)"></p>
        </div>
        <div class="s8-col">
          <p v-for="i in [5,6,7,8]" :key="'s8-r-'+i" class="s8-item" v-html="t(`TskSelectNeedle.AppShell.s8.body${i}`)"></p>
        </div>
      </div>
    </section>

    <!-- ⑨ s9: YouTube Video -->
    <section class="tsn-s9">
      <div class="s9-video-container">
        <iframe 
          src="https://www.youtube.com/embed/cs1eOKwq3PQ" 
          title="YouTube video player" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
          allowfullscreen>
        </iframe>
      </div>
    </section>

    <!-- ⑩ s10: Table -->
    <section class="tsn-s10 table-bleed" :style="{ backgroundImage: `url(${require('@/assets/images/AppShell/products/TSN/TSN_Available-sizes_bg.png')})` }">
      <div class="table-inner">
        <div class="table-head">
          <h3 class="s10-title" v-html="t('model')"></h3>
        </div>

        <div class="table-scroller">
          <table class="table custom-table">
            <thead>
              <tr class="header-row">
                <th scope="col">Gauge</th>
                <th scope="col">Code</th>
                <th scope="col">Description</th>
                <th scope="col">Inch</th>
                <th scope="col">Thin wall</th>
                <th scope="col">Pcs/Box</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(group, groupIndex) in groupedData" :key="groupIndex">
                <tr
                  v-for="(item, itemIndex) in group.items"
                  :key="item.code"
                  :class="getRowClass(displayIndex(groupIndex, itemIndex))"
                >
                  <td v-if="itemIndex === 0" :rowspan="group.items.length" class="gauge-cell">
                    {{ group.gauge }}
                  </td>
                  <td>{{ item.code }}</td>
                  <td>{{ item.description }}</td>
                  <td>{{ item.inch }}</td>
                  <td>{{ item.thinWall }}</td>
                  <td>{{ item.box }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'TSKSelectNeedlePage',
  data() {
    return {
      tableData: [
        { gauge: '34G', code: 'TSN-018004', description: '34G x 4mm', inch: '3/16"', thinWall: '√', box: '100' },
        { gauge: '34G', code: 'TSN-018009', description: '34G x 9mm', inch: '3/8"', thinWall: '√', box: '100' },
        { gauge: '33G', code: 'TSN-020013', description: '33G x 13mm', inch: '1/2"', thinWall: '√', box: '100' },
        { gauge: '30G', code: 'TSN-030025', description: '30G x 25mm', inch: '1"', thinWall: '√', box: '100' },
      ]
    }
  },
  computed: {
    webSrc() {
      return require('@/assets/images/AppShell/products/TSN/web/TSN_01.png')
    },
    phoneSrc() {
      return require('@/assets/images/AppShell/products/TSN/phone/TSN_phone_01.png')
    },
    linkifiedText() {
    const baseText = this.$t('TskSelectNeedle.AppShell.s5.body3')
    return baseText.replace(
      /<link>(.*?)<\/link>/,
      `<a href='https://youtu.be/j-IVTcXsj8k' target='_blank' class='s5-link'>$1</a>`
    )
  },
    groupedData() {
      const groups = this.tableData.reduce((acc, item) => {
        const g = acc.find(group => group.gauge === item.gauge)
        if (g) g.items.push(item)
        else acc.push({ gauge: item.gauge, items: [item] })
        return acc
      }, [])
      return groups
    }

  },
  methods: {
    t(key) { return this.$t ? this.$t(key) : key },
    displayIndex(groupIndex, itemIndex) {
      let index = 0
      for (let i = 0; i < groupIndex; i++) index += this.groupedData[i].items.length
      return index + itemIndex
    },
    getRowClass(index) {
      return index % 2 === 0 ? 'odd-row' : 'even-row'
    }
  }
}
</script>

<style scoped>
.TSN { overflow-x: hidden; }

/* ... (existing styles) ... */

/* ---- S10 Table ---- */
.tsn-s10 {
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 80px 0;
}

.table-inner {
  width: 90%;
  max-width: 1000px;
  margin: 0 auto;
}

.table-head {
  text-align: center;
  margin-bottom: 30px;
}

.s10-title {
  color: #32bebd;
  font-weight: 700;
  font-size: clamp(20px, 2.5vw, 32px);
  margin: 0;
}

.TSN .s10-title {
  color: #32bebd !important;
}

.table-scroller {
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  background: #fff;
}

.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.table th, .table td {
  padding: 12px 16px;
  vertical-align: middle;
  text-align: center;
  font-size: clamp(14px, 1.1vw, 16px);
}

.table thead th {
  background-color: #66c7c6; /* Teal color from image */
  color: #fff;
  font-weight: 700;
  border: none;
}

.gauge-cell {
  background-color: #66c7c6;
  color: #fff;
  font-weight: 700;
  font-size: clamp(16px, 1.3vw, 20px);
  border-bottom: 1px solid rgba(255,255,255,0.2);
}

.custom-table .odd-row { background: #fff; }
.custom-table .even-row { background: #eef8f8; } /* Light teal tint */

@media (max-width: 899px) {
  .tsn-s10 { padding: 40px 0; }
  .table-scroller {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table { min-width: 700px; }
}


.bleed-row {
  --content-pad: 24px;
  position: relative;
  width: calc(100% + (var(--content-pad) * 2));
  margin-left: calc(var(--content-pad) * -1);
  margin-right: calc(var(--content-pad) * -1);
  line-height: 0;
}
@media (max-width: 899px) { .bleed-row { --content-pad: 16px; } }

.row-img { display: block; width: 100%; height: auto; margin: 0; padding: 0; }

.overlay {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  max-width: 42ch;
  padding: 0;
}
.overlay-left  { left: 15%; text-align: left; }

.ov-title { margin: 0 0 12px; font-weight: 700; }
.TSN .ov-title { color: #000 !important; }

.gradient-box {
  display: inline-block;
  padding: 8px 14px;
  border-radius: 8px;
  background: linear-gradient(90deg, rgba(70,156,214,0.9), rgba(209,220,98,0.9));
  color: #fff;
}

.ov-body { font-size: 1rem; line-height: 1.6; margin: 0; }
.bodyp {}
.ov-body-small { margin-top: 8px; font-size: 0.9rem; color: #000; line-height: 1.6; }

/* Mobile S1 Adjustments */
.mobile-only { display: none; }
.desktop-only { display: inline-block; }

@media (max-width: 899px) {
  .overlay {
    top: 15%; /* Move to top */
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    width: 100%;
    max-width: 90%;
  }
  .overlay-left { left: 50%; text-align: center; }
  
  .desktop-only { display: none; }
  .mobile-only { display: block; }
  
  .mobile-subtitle {
    font-size: 1.5rem;
    color: #000;
    margin: 8px 0;
    font-weight: 400;
  }
  
  .ov-title {
    font-size: 2.5rem !important;
    margin-bottom: 0;
  }
  
  .ov-body-small {
    margin-top: 16px;
    font-size: 0.9rem;
    color: #666;
  }
}

/* ---- S2 ---- */
.interstitial-bleed {
  width: 100%;
  background: #f6f6f6;
  padding: 100px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.interstitial-inner { text-align: center; max-width: 800px; margin: 0 auto; }
.inter-title { color: #32bebd !important; font-weight: 700; margin-bottom: 20px; }
.body1 { color: #000; font-weight: 400; margin-bottom: 10px; }
.body2 { color: #000; font-weight: 700; }

@media (max-width: 899px) {
  :deep(.body1 br) { display: none; }
}

/* ---- S3（單一區塊）---- */
.tsn-s3 { width: 100%; margin: 0 auto; }

/* 中央圖區：桌機高度自適應，但不低於 600 */
.s3-center {
  position: relative;
  min-height: clamp(600px, 40vw, 800px);
  height: auto;
  max-width: 1920px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 100px 0; /* 增加上下邊距，避免文字被喀掉 */
}

/* 圖片置中 */
.s3-img {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  height: 100%; width: auto;
  max-width: none;
  display: block;
  z-index: 1;
  opacity: 0.8; /* 稍微降低透明度以增加文字可讀性，視需求調整 */
}

/* 中央大標（覆在圖中央） */
.s3-overlay-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  pointer-events: none;
  width: 100%;
  text-align: center;
}
.s3-title {
  color: #32bebd;
  font-weight: 700;
  font-size: clamp(24px, 3vw, 40px);
  text-align: center;
}
.TSN .s3-title { color: #32bebd !important; }

/* 兩側文字（桌機 only）：疊在圖上 */
.s3-aside {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: min(30ch, 25vw);          /* 縮小欄寬以避免重疊 */
  z-index: 3;
  text-align: left;
}
.s3-aside-left  { left: 5%; }  /* 調整邊距 */
.s3-aside-right { right: 5%; } /* 調整邊距 */

/* 文字樣式 */
.s3-item { margin-bottom: 2em; } /* 再次縮短間距 */
.s3-item-title {
  margin: 0 0 2px;
  color: #32bebd;
  font-weight: 700;
  font-size: clamp(14px, 1.2vw, 16px); /* 進一步縮小上限 */
  text-align: left;
  line-height: 1.3;
}
.s3-item-body {
  margin: 0;
  color: #444; /* 加深顏色增加對比度 */
  line-height: 1.4; /* 縮減行高 */
  font-size: clamp(12px, 1vw, 13px); /* 進一步縮小上限 */
  text-align: left;
}
.s3-mobile-grid { 
  display: none;
  margin: 0;
  padding: 0;
}

/* 手機（<900px）：不疊放。圖片自適應；八則落到下方、兩欄直列 */
@media (max-width: 1200px) {
  .s3-center { height: auto; }
  .s3-img { position: static; transform: none; width: 100%; height: auto; }

  /* 隱藏桌機的左右疊放欄位，改用下方 grid */
  .s3-aside { display: none; }

  .s3-mobile-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 24px;
    max-width: 960px;
    margin: 16px auto 0;
    padding: 0 16px;
  }
  .s3-mcol { display: grid; gap: 16px; }

  .s3-item { margin-bottom: clamp(10px, 1.6vw, 14px); }
  .s3-item-title { font-size: 16px; }
  .s3-item-body  { font-size: 14px; }
}

/* 安全帶（寬度稍窄但仍 ≥900px）時，避免文字蓋到圖中央 */
@media (min-width: 900px) and (max-width: 1200px) {
  .s3-aside { width: min(28ch, 36vw); }
}

/* ---- S4 ---- */
.tsn-s4 { width: 100%; margin: 0 auto; }

.s4-wrap {
  position: relative;
  height: auto;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
  line-height: 0;
}
.s4-img {
  position: relative;
  width: 100%;
  height: auto;
  display: block;
}


/* 疊在左 30%（約略 10% 左邊距），靠左對齊 */
.s4-overlay {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
  width: min(60ch, 40vw);
  z-index: 2;
  text-align: left;
  line-height: normal; /* Reset line-height for text */
}

/* 顏色與排版 */
.s4-title  { color: #32bebd; font-weight: 700; margin: 0 0 10px; font-size: clamp(16px, 2.4vw, 20px); }
.TSN .s4-title { color: #32bebd !important; } /* 防止被全域樣式蓋掉 */

.s4-body1 { color: #000; margin: 0 0 8px; line-height: 1.7; font-size: clamp(14px, 1.2vw, 18px); }
.s4-body2 { color: #666; margin: 0;        line-height: 1.7; font-size: clamp(14px, 1.1vw, 16px); }
.s4-mobile { display: none; }
/* 手機：圖片自適應，文字落到下方 */
@media (max-width: 899px) {
  .s4-wrap   { height: auto; }
  .s4-img    { width: 100%; height: auto; }
  .s4-overlay{ display: none; }

  .s4-mobile {
    display: block;
    padding: 16px;
    max-width: 960px;
    margin: 0 auto;
    text-align: left;
  }
  .s4-title  { font-size: clamp(20px, 5.6vw, 28px); }
  .s4-body1  { font-size: 16px; }
  .s4-body2  { font-size: 14px; }
}

/* ---- S5 ---- */
.tsn-s5 { width: 100%; margin: 0 auto; }

.s5-wrap {
  position: relative;
  height: auto;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
  line-height: 0;
}

.s5-img {
  position: relative;
  width: 100%;
  height: auto;
  display: block;
}

/* 疊在右 50%（約略 50% 左邊距），靠左對齊 */
.s5-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%);
  width: min(60ch, 45vw);
  z-index: 2;
  text-align: left;
  line-height: normal; /* Reset line-height for text */
}

.s5-title {
  color: #32bebd;
  font-weight: 700;
  font-size: clamp(16px, 2.4vw, 20px);
  margin-bottom: 12px;
}
.TSN .s5-title { color: #32bebd !important; }

.s5-body1 {
  color: #000;
  font-weight: 700;
  line-height: 1.6;
  font-size: clamp(14px, 1.2vw, 18px);
}

.s5-body2,
.s5-body3 {
  color: #666;
  line-height: 1.6;
  margin-top: 8px;
  font-size: clamp(14px, 1.1vw, 16px);
}

.s5-link {
  color: #e63946; /* 紅色連結 */
  text-decoration: none;
  cursor: pointer;
  font-weight: 700;
  transition: opacity 0.2s;
}
.s5-link:hover {
  opacity: 0.7;
  text-decoration: underline;
}

/* 表格 */
.s5-table {
  margin-top: 20px;
  border-collapse: collapse;
  width: 100%;
  max-width: 520px;
  border: 2px solid #32bebd;
  background: rgba(255, 255, 255, 0.9); /* 增加半透明背景以確保可讀性 */
}

.s5-table th {
  background: #32bebd;
  color: #fff;
  padding: 8px 12px;
  text-align: center;
  font-weight: 700;
  font-size: clamp(13px, 1vw, 16px);
}
.s5-table td {
  border-top: 1px solid #32bebd;
  color: #32bebd; /* 綠色文字 */
  padding: 8px 12px;
  text-align: center;
  font-weight: 700;
  font-size: clamp(13px, 1vw, 16px);
}
.s5-table tr:nth-child(even) td {
  background: rgba(50, 190, 189, 0.05);
}

.s5-tip {
  margin-top: 12px;
  font-size: 0.8rem;
  color: #666;
  text-align: right;
  max-width: 520px;
}

.s5-mobile { display: none; }

/* 手機版 */
@media (max-width: 899px) {
  .s5-wrap   { height: auto; }
  .s5-img    { position: static; transform: none; width: 100%; height: auto; }
  .s5-overlay{ display: none; }

  .s5-mobile {
    display: block;
    padding: 24px 16px;
    max-width: 960px;
    margin: 0 auto;
    text-align: left;
  }
  .s5-title {
    font-size: clamp(20px, 5vw, 28px);
  }
  .s5-body1 { font-size: 16px; }
  .s5-body2, .s5-body3 { font-size: 14px; }
  
  .s5-table {
    width: 100%;
    max-width: 100%;
    background: #fff;
  }
  .s5-tip {
    text-align: right;
    max-width: 100%;
  }
}




/* ---- S6 ---- */
.tsn-s6 {
  padding: 80px 20px;
  background: #fff; /* 如果之後想整區換別色，再調這個 */
  text-align: center;
}

.s6-content {
  max-width: 1000px;
  margin: 0 auto;
}

.s6-title {
  color: #32bebd;
  font-weight: 700;
  font-size: clamp(20px, 2.4vw, 32px);
  margin-bottom: 20px;
}
.TSN .s6-title { color: #32bebd !important; }

.s6-body {
  color: #666;
  line-height: 1.8;
  margin-bottom: 40px;
  font-size: clamp(14px, 1.1vw, 16px);
}

.s6-images {
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
}

/* 拿掉白色卡片 & 陰影 & 底部 padding */
.s6-img-group {
  flex: 1;
  min-width: 300px;
  max-width: 450px;
  background: transparent;   /* 原本是 #fff */
  box-shadow: none;          /* 原本有陰影 */
  border-radius: 0;          /* 不需要卡片圓角 */
  padding-bottom: 0;         /* 拿掉圖片下方那條白底空間 */
  overflow: visible;
}

/* 讓 wrapper 只負責排版，不限制比例、不加底色 */
.img-wrapper {
  width: 100%;
  /* aspect-ratio: 16/9;  移除，避免圖片被硬拉比例 */
  margin-bottom: 0;
  overflow: visible;
  background: transparent;
}

/* 圖片照原來大小等比例顯示＋置中 */
.img-wrapper img {
  display: block;
  margin: 0 auto;
  width: auto;
  max-width: 100%;
  height: auto;
  object-fit: contain;  /* 避免被裁切 */
  transition: transform 0.3s ease;
}

/* hover 還是可以保留微放大效果 */
.s6-img-group:hover .img-wrapper img {
  transform: scale(1.05);
}

.s6-caption-box {
  padding: 0 20px;
}

.s6-caption {
  font-size: 1.1rem;
  margin-bottom: 8px;
  color: #333;
}

.s6-desc {
  font-size: 0.95rem;
  color: #666;
}

/* Mobile 調整 */
@media (max-width: 768px) {
  .tsn-s6 {
    padding: 40px 16px;
  }
  
  .s6-images {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
  
  .s6-img-group {
    width: 100%;
    max-width: 100%;
  }
}

/* ---- S7 ---- */
.tsn-s7 {
  padding: 80px 20px;
  background: #fff; /* Or slightly different bg if needed */
  text-align: center;
}

.s7-content {
  max-width: 800px;
  margin: 0 auto;
}

.s7-title {
  color: #32bebd;
  font-weight: 700;
  font-size: clamp(20px, 2.4vw, 32px);
  margin-bottom: 20px;
}
.TSN .s7-title { color: #32bebd !important; }

.s7-body {
  color: #666;
  line-height: 1.8;
  margin-bottom: 40px;
  font-size: clamp(14px, 1.1vw, 16px);
}

.s7-diagram {
  position: relative;
  max-width: 600px;
  margin: 0 auto;
}

.s7-img {
  width: 100%;
  height: auto;
  display: block;
}

.s7-labels {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 0 10%;
}

.s7-label-item {
  font-weight: 700;
}

/* Mobile Adjustments */
@media (max-width: 768px) {
  .tsn-s6, .tsn-s7 {
    padding: 40px 16px;
  }
  
  .s6-images {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
  
  .s6-img-group {
    width: 100%;
    max-width: 100%;
  }
}

/* ---- S8 ---- */
.tsn-s8 {
  width: 100%;
  margin-bottom: 80px;
  margin-top: 60px;
}

.s8-header {
  background: #32bebd;
  padding: 24px 20px;
  text-align: center;
  max-width: 1000px;
  margin: 0 auto;
}

.s8-title {
  color: #fff !important;
  font-weight: 700;
  font-size: clamp(18px, 2.2vw, 26px);
  margin: 0;
  line-height: 1.4;
}

.s8-content {
  max-width: 1000px;
  margin: 50px auto 0;
  display: flex;
  justify-content: center;
  gap: 40px 80px;
  flex-wrap: wrap;
  padding: 0 20px;
}

.s8-col {
  flex: 1;
  min-width: 300px;
  max-width: 480px;
}

.s8-item {
  font-size: clamp(14px, 1.1vw, 16px);
  color: #666;
  margin-bottom: 20px;
  line-height: 1.6;
  font-weight: 400;
  text-align: left;
}

@media (max-width: 768px) {
  .s8-content {
    flex-direction: column;
    gap: 10px;
    margin-top: 30px;
  }
  .s8-col {
    min-width: 100%;
  }
  .s8-item {
    margin-bottom: 12px;
  }
}

/* ---- S9 ---- */
.tsn-s9 {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto 100px;
  padding: 0 20px;
}

.s9-video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 */
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}

.s9-video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.TSN { --headline-size: clamp(20px, 2.8vw, 34px); --headline-line-height: 1.15; --headline-letter: .01em; }
@supports (font-size: 1cqw) { .TSN { --headline-size: clamp(20px, 4.6cqw, 34px); } }
.ov-title { font-size: var(--headline-size) !important; line-height: var(--headline-line-height) !important; letter-spacing: var(--headline-letter) !important; }
</style>
